import Box from '@/components/UI/Box';
import Chip from '@/components/UI/Chip';
import Text from '@/components/UI/Text';
import type { EventStatusEnum } from '@/gql/scalars';
import eventStatus from '@/utils/eventStatus';

const statuses: {
  title: string;
  value: EventStatusEnum;
}[] = [
  {
    title: eventStatus.completed,
    value: 'completed',
  },
  {
    title: eventStatus.postponed,
    value: 'postponed',
  },
  {
    title: eventStatus.cancelled,
    value: 'cancelled',
  },
];

type TagGroupSelectProps = {
  selected: string[];
  onPress: (id: EventStatusEnum | null) => void;
};

export default function EventStatusSelect({
  selected,
  onPress,
}: TagGroupSelectProps) {
  return (
    <Box direction="vertical" p="md" space="xs">
      <Text bold size="xl">
        Game Status
      </Text>
      <Box direction="horizontal" wrap space="xs">
        <Chip
          aria-label="None"
          label="None"
          onValueChange={() => onPress(null)}
          value={selected.length === 0}
        />
        {statuses?.map((status) => {
          const isChecked = selected.includes(status.value);

          return (
            <Chip
              key={status.value}
              aria-label={status.title}
              label={status.title}
              onValueChange={() => onPress(status.value)}
              value={isChecked}
            />
          );
        })}
      </Box>
    </Box>
  );
}
